<template>
    <el-dialog
        width="500px"
        :title="type==1? '专利值' : '专利文件'"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" :rules="rules" size="mini" label-width="130px">
            <el-form-item label="专利值：" v-if="type == 1">
                <el-input v-model="formData.patent_value" style="width: 200px;margin-right:20px;" size="mini"
                          placeholder="请输入专利值"></el-input>
            </el-form-item>

            <el-upload
                class="upload-demo"
                drag
                action="/"
                :file-list="fileList"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :auto-upload="false"
                multiple
                v-if="type == 2"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                </div>
                <div
                    class="el-upload__text"
                    style="font-size: 12px;margin-top: 5px;"
                >
                </div>
            </el-upload>

        </el-form>

        <el-row style="margin-top:17px; ">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">关 闭
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm()" :loading="loading">修 改
            </el-button>
        </el-row>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'

    export default {
        name: 'updatePatent',
        data() {
            return {
                visible: false,
                loading: false,
                formData: {},
                rules: {},
                type: 1,

                fileList: [],
                obj: {},
                disabled: false,
                filesize: 0,
                value: '',
                file_data: null
            }
        },
        methods: {
            //上传Excel文件的处理方法
            handleChange(file, fileList) {
                if (fileList.length > 1) {
                    this.fileList = [fileList[fileList.length - 1]]
                }
                this.fileTemp = file.raw
                // let extend = this.fileTemp.name.substring(
                //     this.fileTemp.name.lastIndexOf('.'),
                //     this.fileTemp.name.length
                // )
                if (this.fileTemp) {
                    // if (extend == '.xlsx' || extend == '.xls' || extend == '.csv') {
                        this.file_data = this.fileTemp
                        this.filesize = this.fileTemp.size
                    // } else {
                    //     this.$message({
                    //         type: 'warning',
                    //         message: '附件格式错误，请删除后重新上传!'
                    //     })
                    // }
                } else {
                    this.$message({
                        type: 'warning',
                        message: '请上传附件!'
                    })
                }
            },
            //超过上载文件的最大数量限制如何删除文件
            handleRemove() {
                this.fileList = []
                this.fileTemp = null
                this.file_data = null
                this.obj = {}
            },
            openModal(type, data) {
                this.type = type
                const tempData = JSON.parse(JSON.stringify(data))
                this.formData = tempData
                this.visible = true
            },
            submitForm() {
                if(this.type == 2) {
                    if (this.file_data == null) {
                        this.$message({
                            type: 'error',
                            message: '请上传符合格式数据文件！'
                        })
                        return
                    }
                    if (this.filesize / 1024 / 1024 > 10) {
                        this.$message({
                            type: 'error',
                            message: '请上传小于10MB 的数据！'
                        })
                        return
                    }
                    if (this.filesize / 1024 / 1024 > 1) {
                        this.$notify.info({
                            title: '提示',
                            message: '文件过大，数据处理大约需要1~2分钟',
                            duration: 30000
                        })
                    }
                }
                this.loading = true

                var file = new FormData()
                file.append('id', this.formData.id)
                if(this.type == 1) {
                    file.append('patent_value', this.formData.patent_value)
                }
                if(this.type == 2) {
                    file.append('patent_file', this.file_data)
                }
                api.cost_analysis_personal_update_patent(file).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.$message({message: '修改成功', type: 'success'})
                        this.handleClose(true)
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.loading = false
                    this.$message({type: 'error', message: '网络出现问题，请刷新页面！'})
                })
            },

            // 关闭弹窗
            handleClose(isshow = false) {
                this.visible = false
                this.$emit('close-callback', isshow)
            }
        }
    }
</script>

